import { ArrowDown } from "lucide-react";
import { Link } from "react-router-dom";
import PageMeta from "../components/PageMeta";
import { RequestButton, ArrowLink, ContactCTA } from "../components/SiteShell";
import ServiceAccordion from "../components/ServiceAccordion";
import PropertyPreview from "../components/PropertyPreview";
import FAQ from "../components/FAQ";
import { properties } from "../content";

export default function Home() {
  return (
    <>
      <PageMeta
        title="Owners First | Built to put Owners First"
        description="Personal, hands-on owners corporation management in Melbourne. Property care, clear communication and a manager who shows up."
      />
      <section className="site-hero" aria-labelledby="home-title">
        <img
          className="site-hero-image"
          src="/images/architecture.jpg"
          alt="Sunlit apartment architecture with curved balconies and planted terraces"
          fetchpriority="high"
          width="1792"
          height="1024"
        />
        <div className="site-hero-shade" />
        <div className="site-wrap site-hero-content">
          <h1 id="home-title">
            Built to put
            <br />
            <span>Owners First</span>
          </h1>
          <div className="site-hero-bottom">
            <div>
              <p>
                Owners corporation management
                <br />
                with people at its heart.
              </p>
              <RequestButton />
            </div>
            <a className="site-scroll-link" href="#our-approach">
              <span>Discover the Owners First difference</span>
              <ArrowDown aria-hidden="true" />
            </a>
          </div>
        </div>
      </section>
      <section id="our-approach" className="site-wrap site-introduction">
        <h2>
          A well-run building.
          <br />
          <span>
            A community
            <br className="site-mobile-break" /> that feels heard.
          </span>
        </h2>
        <div className="site-introduction-copy">
          <p>
            Good management is about more than keeping things ticking over. It’s
            knowing your building, listening to its people and taking care of
            the details before they become distractions.
          </p>
          <p>We bring that thinking to every owners corporation we manage.</p>
          <ArrowLink to="/about">Our approach</ArrowLink>
        </div>
      </section>
      <section className="site-surface site-section">
        <div className="site-wrap site-services-layout">
          <div className="site-section-intro">
            <h2>
              Every detail.
              <br />
              Taken care of.
            </h2>
            <p>
              Practical support for your property, your committee and your
              community.
            </p>
            <ArrowLink to="/services">Explore our services</ArrowLink>
          </div>
          <ServiceAccordion />
        </div>
      </section>
      <section className="site-wrap site-section">
        <div className="site-section-heading">
          <h2>
            Different places.
            <br />
            The same care.
          </h2>
          <ArrowLink to="/portfolio">Our communities</ArrowLink>
        </div>
        <div className="site-property-grid">
          {properties.slice(0, 3).map((property) => (
            <PropertyPreview key={property.id} property={property} />
          ))}
        </div>
      </section>
      <section className="site-care-story">
        <div className="site-care-image">
          <img
            src="/images/community.jpg"
            alt="Neighbours talking in a planted shared apartment courtyard"
            loading="lazy"
            width="1792"
            height="1024"
          />
        </div>
        <div className="site-wrap site-care-copy">
          <h2>
            Good management
            <br />
            starts with showing up.
          </h2>
          <div>
            <p>
              At least four visits to your property each year. A familiar face.
              A clear conversation. It’s a simple commitment that makes a real
              difference.
            </p>
            <Link className="site-text-link" to="/about#our-promise">
              Read our service promise<span aria-hidden="true">↗</span>
            </Link>
          </div>
        </div>
      </section>
      <FAQ />
      <ContactCTA />
    </>
  );
}
